export type DialogType = 'SUCCESS' | 'FAIL' | 'INFO';

export const DialogType = {
  SUCCESS: 'SUCCESS' as DialogType,
  FAIL: 'FAIL' as DialogType,
  INFO: 'INFO' as DialogType,
};
